import { ENV } from "../utils";

export class EnvironmentalRiskMatrixConesaform {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrixConesa(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-conesa/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrixConesa(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix-conesa`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrixConesa(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-conesa/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrixConesa(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix-conesa/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesConesaBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-conesa-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
